import Chart from "chart.js";
import WatermarkPlugin from "./plugins/watermark";
import BackgroundPlugin from "./plugins/background";

Chart.pluginService.register(WatermarkPlugin);
Chart.pluginService.register(BackgroundPlugin);

if (Chart.defaults.global.legend) {
  Chart.defaults.global.legend.align = "start";
  Chart.defaults.global.legend.position = "bottom";

  if (Chart.defaults.global.legend.labels) {
    Chart.defaults.global.legend.labels.boxWidth = 10;
    Chart.defaults.global.legend.labels.fontSize = 10;
    Chart.defaults.global.legend.labels.fontColor = "#9FABBC";
    Chart.defaults.global.legend.labels.usePointStyle = true;
    Chart.defaults.global.legend.labels.padding = 20;
  }
}

Chart.defaults.global.responsive = true;
Chart.defaults.global.maintainAspectRatio = false;

Chart.defaults.global.tooltips.backgroundColor = "#252F50";
Chart.defaults.global.tooltips.xPadding = 10;
Chart.defaults.global.tooltips.yPadding = 10;
Chart.defaults.global.tooltips.displayColors = false;

if (Chart.defaults.global.elements && Chart.defaults.global.elements.point) {
  Chart.defaults.global.elements.point.radius = 2;
}
